var _a;
import { global } from '../core/GlobalState';
import * as THREE from 'three';
const languageOrbSizes = 150;
// Arrow profile that clearly points from A→B
const arrowToTarget = {
    arrows: { start: false, end: true },
};
const timeGap = global.baseTimeGap; // default time gap for spraying orbs
/** Explicitly defining how each orb looks and behaves */
const orbConfigs = {
    TEST_PORTAL_ORB: {
        radius: languageOrbSizes / 2,
        textColor: 0xffffff,
        defaultLayerScaleFactor: 0.05,
        layers: [
            { shape: 'sphere', color: 0x27ccbb },
            { shape: 'sphere', color: 0x7F87F8 },
        ],
        isPortal: true,
        portalTargetSceneName: 'system',
        portalResolution: 512,
        portalCameraFOV: 70, // ✅ Optional, use if you want different perspective
    },
    BLACKHOLE: {
        radius: 300,
        textColor: 0x000000,
        defaultLayerScaleFactor: 0.025,
        layers: [
            { shape: 'sphere', color: 0x000000, side: THREE.FrontSide, scaleFactor: 1.0 },
            { shape: 'sphere', color: 0x3333cc },
            { shape: 'sphere', color: 0x6666e6 },
            { shape: 'sphere', color: 0x9999ff },
            { shape: 'sphere', color: 0xb3bdff },
            { shape: 'sphere', color: 0xccd9ff },
            { shape: 'sphere', color: 0xe6e6ff },
            { shape: 'sphere', color: 0xfafafa },
            { shape: 'sphere', color: 0xffffff },
        ],
        actions: [
            {
                trigger: 'onActivate',
                kind: 'sprayFromFetcher',
                options: {
                    fetcher: 'githubOrbs',
                    args: {},
                    baseVelocity: 5,
                    sprayCoefficient: 2100,
                    timeGap: timeGap
                }
            },
            {
                trigger: 'onActivate',
                kind: 'sprayFromFetcher',
                options: {
                    fetcher: 'dockerOrbs',
                    args: {},
                    baseVelocity: 5,
                    sprayCoefficient: 2100,
                    timeGap: timeGap
                }
            },
            {
                trigger: 'onActivate',
                kind: 'sprayFromFetcher',
                options: {
                    fetcher: 'dockerOrbs',
                    args: {},
                    baseVelocity: 5,
                    sprayCoefficient: 2100,
                    timeGap: timeGap
                }
            },
            {
                trigger: 'onActivate',
                kind: 'sprayFromFetcher',
                options: {
                    fetcher: 'endpointOrbs',
                    args: {},
                    baseVelocity: 5,
                    sprayCoefficient: 2100,
                    timeGap: timeGap
                }
            },
            {
                trigger: 'onActivate',
                kind: 'sprayFromFetcher',
                options: {
                    fetcher: 'dockerSwarmOrbs',
                    args: {},
                    baseVelocity: 5,
                    sprayCoefficient: 2100,
                    timeGap: timeGap
                }
            },
            {
                trigger: 'onActivate',
                kind: 'sprayFromFetcher',
                options: {
                    fetcher: 'registryOrbs',
                    args: {},
                    baseVelocity: 5,
                    sprayCoefficient: 2100,
                    timeGap: timeGap
                }
            },
            {
                trigger: 'onActivate',
                kind: 'sprayFromFetcher',
                options: {
                    fetcher: 'desmosOrbs',
                    args: {},
                    baseVelocity: 5,
                    sprayCoefficient: 2100,
                    timeGap: timeGap
                }
            },
            {
                trigger: 'onActivate',
                kind: 'sprayFromFetcher',
                options: {
                    fetcher: 'chatbotOrbs',
                    args: {},
                    baseVelocity: 5,
                    sprayCoefficient: 2100,
                    timeGap: timeGap
                }
            },
            {
                trigger: 'onActivate',
                kind: 'sprayFromFetcher',
                options: {
                    fetcher: 'promptOrbs',
                    args: {},
                    baseVelocity: 5,
                    sprayCoefficient: 2100,
                    timeGap: timeGap
                }
            },
            {
                trigger: 'onActivate',
                kind: 'sprayFromFetcher',
                options: {
                    fetcher: 'mathIdentityOrbs',
                    args: {},
                    baseVelocity: 5,
                    sprayCoefficient: 2100,
                    timeGap: timeGap
                }
            },
            {
                trigger: 'onActivate',
                kind: 'sprayFromFetcher',
                options: {
                    fetcher: 'textBlurbOrbs',
                    args: {},
                    baseVelocity: 5,
                    sprayCoefficient: 2100,
                    timeGap: timeGap
                }
            }
        ]
    },
    BLACKHOLE_ALT: {
        radius: 100,
        textColor: 0xffffff,
        defaultLayerScaleFactor: 0.025,
        layers: [
            { shape: 'sphere', color: 0x27ccbb },
            { shape: 'sphere', color: 0x2d6af7 },
            { shape: 'sphere', color: 0x7F87F8 },
            { shape: 'sphere', color: 0xbabfff },
            { shape: 'sphere', color: 0xd7d9f7 },
        ],
    },
    WHITEHOLE: {
        radius: 300,
        textColor: 0xffffff,
        defaultLayerScaleFactor: 0.007,
        layers: [
            { shape: 'sphere', color: 0xffffff },
            { shape: 'sphere', color: 0xe6e6ff },
            { shape: 'sphere', color: 0xccd9ff },
            { shape: 'sphere', color: 0xb3bdff },
            { shape: 'sphere', color: 0x99ccff },
            { shape: 'sphere', color: 0x80e0ff },
            { shape: 'sphere', color: 0x66ffd9 },
            { shape: 'sphere', color: 0x80ff80 },
            { shape: 'sphere', color: 0xccff66 },
            { shape: 'sphere', color: 0xffe066 },
            { shape: 'sphere', color: 0xffb366 },
            { shape: 'sphere', color: 0xff8080 },
            { shape: 'sphere', color: 0xff4d6e },
            { shape: 'sphere', color: 0xff1a53 }, // Deep Red
        ],
    },
    CLASSIC: {
        radius: languageOrbSizes / 2,
        textColor: 0xffffff,
        defaultLayerScaleFactor: 0.05,
        layers: [
            { shape: 'sphere', color: 0x27ccbb },
            { shape: 'sphere', color: 0x7F87F8 },
        ],
        textCanvasScale: 2
    },
    CLIENT_ORB: {
        radius: 5.25,
        textColor: 0xd9dee7,
        defaultLayerSide: THREE.BackSide,
        defaultLayerScaleFactor: 0.12,
        layers: [
            // Opaque silvery center
            { shape: 'sphere', color: 0xbdc7d8, transparent: false, opacity: 1, depthWrite: true },
            // Opaque neon shell
            { shape: 'sphere', color: 0x4b8dff, transparent: false, opacity: 1, depthWrite: true, scaleFactor: 0.18 },
        ],
    },
    TEST_NEST: {
        radius: 40,
        textColor: 0xffffff,
        defaultLayerScaleFactor: 0.05,
        layers: [
            { shape: 'sphere', color: 0xff0000 },
            { shape: 'sphere', color: 0x00ff00 },
            { shape: 'sphere', color: 0x0000ff },
            { shape: 'sphere', color: 0xffff00 },
            { shape: 'sphere', color: 0xff00ff },
            { shape: 'sphere', color: 0x00ffff },
            { shape: 'sphere', color: 0xffffff },
        ],
    },
    RAINBOW_NEST: {
        radius: 50,
        textColor: 0xffffff,
        defaultLayerScaleFactor: 0.2,
        layers: [
            { shape: 'sphere', color: 0xff0000 },
            { shape: 'sphere', color: 0xff2000 },
            { shape: 'sphere', color: 0xff4000 },
            { shape: 'sphere', color: 0xff6000 },
            { shape: 'sphere', color: 0xff8000 },
            { shape: 'sphere', color: 0xffa000 },
            { shape: 'sphere', color: 0xffbf00 },
            { shape: 'sphere', color: 0xffdf00 },
            { shape: 'sphere', color: 0xffff00 },
            { shape: 'sphere', color: 0xdfff00 },
            { shape: 'sphere', color: 0xbfff00 },
            { shape: 'sphere', color: 0x9fff00 },
            { shape: 'sphere', color: 0x80ff00 },
            { shape: 'sphere', color: 0x60ff20 },
            { shape: 'sphere', color: 0x40ff40 },
            { shape: 'sphere', color: 0x20ff60 },
            { shape: 'sphere', color: 0x00ff80 },
            { shape: 'sphere', color: 0x00ffa0 },
            { shape: 'sphere', color: 0x00ffbf },
            { shape: 'sphere', color: 0x00ffdf },
            { shape: 'sphere', color: 0x00ffff },
            { shape: 'sphere', color: 0x00dfff },
            { shape: 'sphere', color: 0x00bfff },
            { shape: 'sphere', color: 0x009fff },
            { shape: 'sphere', color: 0x0080ff },
            { shape: 'sphere', color: 0x0060ff },
            { shape: 'sphere', color: 0x0040ff },
            { shape: 'sphere', color: 0x4020ff },
            { shape: 'sphere', color: 0x8000ff },
            { shape: 'sphere', color: 0xbf00ff },
            { shape: 'sphere', color: 0xdf00ff },
            { shape: 'sphere', color: 0xff00ff },
            { shape: 'sphere', color: 0xff00df },
            { shape: 'sphere', color: 0xff00bf },
            { shape: 'sphere', color: 0xff009f },
            { shape: 'sphere', color: 0xff0080 },
            { shape: 'sphere', color: 0xff0060 },
            { shape: 'sphere', color: 0xff0040 },
            { shape: 'sphere', color: 0xff2020 },
            { shape: 'sphere', color: 0xff0000 },
        ],
    },
    TEST_ORB: {
        radius: 5,
        textColor: 0xffffff,
        defaultLayerScaleFactor: 1.5,
        layers: [
            { shape: 'sphere', color: 0x000000 },
            { shape: 'sphere', color: 0x444444 },
            { shape: 'sphere', color: 0x888888 },
        ],
    },
    TEST_PROJECTILE: {
        radius: 4,
        textColor: 0xffffff,
        defaultLayerScaleFactor: 0.8,
        layers: [
            { shape: 'sphere', color: 0x333333 },
            { shape: 'sphere', color: 0xffffff },
        ],
    },
    API_ORB: {
        radius: 70,
        textColor: 0xffffff,
        defaultLayerScaleFactor: 0.08,
        layers: [
            { shape: 'sphere', color: 0x27ccbb },
            { shape: 'sphere', color: 0x7F87F8 },
        ],
        actions: [
            {
                trigger: 'onActivate',
                kind: 'callOrbAction',
                params: {
                    byType: 'BLACKHOLE',
                    first: true,
                    action: 'onActivate'
                }
            }
        ]
    },
    HTTP_ORB: {
        radius: 54,
        textColor: 0xd7f9ff,
        textOutlineColor: 0x0a314a,
        defaultLayerScaleFactor: 0.16,
        layers: [
            { shape: 'sphere', color: 0x0a314a, transparent: true, opacity: 0.6 },
            { shape: 'sphere', color: 0x1f9bf0, transparent: true, opacity: 0.45 },
            { shape: 'sphere', color: 0x9be7ff, transparent: true, opacity: 0.3 },
        ],
        textCanvasScale: 1.8,
    },
    STREAM_STATUS_ORB: {
        radius: 22,
        textColor: 0xffffff,
        textOutlineColor: 0x000000,
        defaultLayerScaleFactor: 0.12,
        layers: [
            { shape: 'sphere', color: 0x2ecc71, transparent: false, opacity: 1 },
            { shape: 'sphere', color: 0xffffff, transparent: false, opacity: 1 },
        ],
        textCanvasScale: 2,
    },
    SPHERE_ORB: {
        radius: 15,
        textColor: 0x713cfd,
        textOutlineColor: 0x1c3eed,
        defaultLayerScaleFactor: 0.08,
        layers: [
            { shape: 'sphere', color: 0x27ccbb },
            { shape: 'sphere', color: 0x7F87F8 },
        ],
    },
    // Code Language Orbs
    BASH_ORB: genLangOrb(0x89e051, 0xf0f0f0),
    JAVA_ORB: genLangOrb(0xf49518, 0x04748c),
    PYTHON_ORB: genLangOrb(0x32d190, 0x5FB43A),
    POWERSHELL_ORB: genLangOrb(0x477CDA, 0x2AAACD),
    GO_ORB: genLangOrb(0x00ADD8, 0xf0f0f0),
    RUST_ORB: genLangOrb(0xDD3515, 0xEF4A00),
    JAVASCRIPT_ORB: genLangOrb(0x3178C6, 0xf0f0f0),
    TYPESCRIPT_ORB: genLangOrb(0x3178C6, 0xf0f0f0),
    ANSIBLE_ORB: genLangOrb(0xCC0000, 0xf0f0f0),
    // Other types
    //MATH_ORB: genLangOrb(0xdee0ff, 0x7F87F8),
    MATH_ORB: {
        radius: 150,
        textColor: 0xf0f0f0,
        textOutlineColor: 0xf0f0f0,
        defaultLayerScaleFactor: 0.08,
        imageUrlPath: 'id',
        imageUrlTemplate: 'https://api.orbscape.io/rendermathimage?from=${encodedValue}&fmt=svg&color=white&fontSize=22&scale=1',
        //imageUrlTemplate: 'https://api.orbscape.io/rendermathimage?from=${encodedValue}',
        imageMaskStyle: 'circle',
        imageSize: 256,
        imageSpriteScale: 216,
        layers: [
            { shape: 'sphere', color: 0x6171fa },
            //{ shape: 'sphere', color: 0x7F87F8 },//, rotationSpeed: new THREE.Vector3(0.01, 0.01, 0.01) },
            { shape: 'sphere', color: 0xdee0ff },
            //{ shape: 'sphere', color: 0x7F87F8 },
        ],
    },
    //DESMOS_ORB: genLangOrb(0x0BA020, 0xf0f0f0),
    DESMOS_ORB: {
        radius: 150,
        textColor: 0xffffff,
        defaultLayerScaleFactor: 0.08,
        imageUrlPath: "thumbnail_url",
        imageMaskStyle: "circle",
        imageSize: 256,
        //imageRadius: 32,
        imageSpriteScale: 216,
        nestedExpansion: {
            enabled: true,
            parser: 'desmosExpressions',
            autoConnectParent: true,
            parentConnectionProfile: {
                style: { color: 0x26a69a, widthPx: 2.5 },
                arrows: { end: true, start: false, size: 6 },
                elastic: {
                    enabled: true,
                    rest: 540,
                    stiffness: 5.5,
                    damping: 2.4,
                    transverseDamping: 1.8,
                    maxForce: 210,
                    minSeparation: 24,
                    maxDistance: 1400,
                    impulseScale: 0.85,
                    deadband: 6,
                },
            },
            spray: {
                enabled: true,
                baseVelocity: 2.2,
                sprayCoefficient: 780,
                timeGap: timeGap * 5,
                drag: 0.92,
            },
        },
        layers: [
            { shape: 'sphere', color: 0x0BA020 },
            { shape: 'sphere', color: 0xf0f0f0 },
        ],
    },
    DESMOS_LATEX: {
        radius: 110,
        textColor: 0xeceff1,
        textOutlineColor: 0x1a237e,
        defaultLayerScaleFactor: 0.08,
        layers: [
            { shape: 'sphere', color: 0x283593 },
            { shape: 'sphere', color: 0x9fa8da },
        ],
    },
    DESMOS_TEXT: {
        radius: 110,
        textColor: 0xf5f5f5,
        textOutlineColor: 0x004d40,
        defaultLayerScaleFactor: 0.08,
        layers: [
            { shape: 'sphere', color: 0x006064 },
            { shape: 'sphere', color: 0xb2ebf2 },
        ],
    },
    DESMOS_FOLDER: {
        radius: 120,
        textColor: 0xf8f4ff,
        textOutlineColor: 0x311b92,
        defaultLayerScaleFactor: 0.08,
        edgeProfiles: {
            folderChild: {
                style: { color: 0x7c4dff, widthPx: 3 },
                arrows: { end: true, start: false, size: 8 },
                elastic: {
                    enabled: true,
                    rest: 520,
                    stiffness: 4.2,
                    damping: 2.1,
                    transverseDamping: 1.6,
                    maxForce: 190,
                    minSeparation: 24,
                    maxDistance: 1200,
                    impulseScale: 0.82,
                },
            },
        },
        defaultEdgeProfile: {
            name: 'desmos_folder_child',
            style: { color: 0x7c4dff, widthPx: 3 },
            arrows: { end: true, start: false, size: 8 },
            elastic: {
                enabled: true,
                rest: 520,
                stiffness: 4.2,
                damping: 2.1,
                transverseDamping: 1.6,
                maxForce: 190,
                minSeparation: 24,
                maxDistance: 1200,
                impulseScale: 0.82,
            },
        },
        layers: [
            { shape: 'sphere', color: 0x4527a0 },
            { shape: 'sphere', color: 0xce93d8 },
        ],
    },
    //GITHUB_ORB: genLangOrb(0xf04c34, 0xf0f0f0),
    GITHUB_ORB: {
        radius: 150,
        textColor: 0xf0f0f0,
        textOutlineColor: 0xf0f0f0,
        defaultLayerScaleFactor: 0.08,
        layers: [
            { shape: 'octahedron', color: 0xf04c34 },
            { shape: 'octahedron', color: 0xf0f0f0 },
            { shape: 'sphere', color: 0xf29086 },
            { shape: 'sphere', color: 0xf0f0f0 },
        ],
        actions: [
            {
                trigger: 'onActivate',
                // new shape (works with old too):
                kind: 'sprayFromFetcher',
                params: {
                    fetcher: 'languageByRepo',
                    args: { repoName: '@data.name' },
                    count: 10,
                    baseVelocity: 5,
                    sprayCoefficient: 2100,
                    timeGap: timeGap,
                    // drag: 0.99 // optional
                }
            }
        ],
        connectionProfiles: [
            {
                label: 'Connect GitHub to Registry',
                toType: 'CONTAINER_IMAGE_ORB',
                buildSourceKey: (d) => {
                    var _a, _b, _c;
                    const name = ((_a = d === null || d === void 0 ? void 0 : d.name) !== null && _a !== void 0 ? _a : '').toLowerCase();
                    const shortHash = ((_c = (_b = d === null || d === void 0 ? void 0 : d.short_commit_hash) !== null && _b !== void 0 ? _b : d === null || d === void 0 ? void 0 : d.shortCommitHash) !== null && _c !== void 0 ? _c : '').toLowerCase();
                    if (!name || !shortHash)
                        return undefined;
                    const matchName = `${name}:${shortHash}`;
                    const altMatchName = `${name}:latest`;
                    //console.log(matchName)
                    return altMatchName;
                },
                buildTargetKey: (d) => { var _a; return ((_a = d === null || d === void 0 ? void 0 : d.displayName) !== null && _a !== void 0 ? _a : '').toLowerCase(); },
                edgeProfile: {
                    style: {
                        color: 0xf04c34,
                        widthPx: 3,
                        distanceStyle: {
                            widthPx: { near: 200, far: 2400, min: 1, max: 5 }
                        }
                    },
                    arrows: { start: false, end: true, size: 10 },
                    curve: { mode: 'straight', bend: 0.18, segments: 20 },
                    elastic: {
                        enabled: true,
                        rest: 1300,
                        stiffness: 2,
                        damping: 6,
                        transverseDamping: 4,
                        maxForce: 10,
                        // NEW: make it extra gentle & only move endpoints
                        impulseScale: 0.25,
                        applyTo: 'b',
                        maxSpeed: 6,
                        deadband: 5,
                        minSeparation: 1100,
                        minRestLength: 0
                    }
                }
            },
            {
                label: 'Connect GitHub to Containers',
                toType: 'DOCKER_CONTAINER_ORB',
                buildSourceKey: (d) => { var _a; return ((_a = d === null || d === void 0 ? void 0 : d.name) !== null && _a !== void 0 ? _a : '').toLowerCase(); },
                buildTargetKey: (d) => { var _a, _b; return ((_b = (_a = d === null || d === void 0 ? void 0 : d.BaseName) !== null && _a !== void 0 ? _a : d === null || d === void 0 ? void 0 : d.baseName) !== null && _b !== void 0 ? _b : '').toLowerCase() || undefined; },
                edgeProfile: {
                    style: {
                        color: 0xf04c34,
                        widthPx: 3,
                        distanceStyle: {
                            widthPx: { near: 200, far: 2400, min: 1, max: 5 }
                        }
                    },
                    arrows: { start: false, end: true, size: 10 },
                    curve: { mode: 'straight', bend: 0.18, segments: 20 },
                    elastic: {
                        enabled: true,
                        rest: 900,
                        stiffness: 2,
                        damping: 6,
                        transverseDamping: 4,
                        maxForce: 10,
                        // NEW: make it extra gentle & only move endpoints
                        impulseScale: 0.25,
                        applyTo: 'b',
                        maxSpeed: 6,
                        deadband: 5,
                        minSeparation: 700,
                        minRestLength: 0
                    }
                }
            }
        ],
    },
    //DOCKER_CONTAINER_ORB: genLangOrb(0x1D63ED, 0xf0f0f0),
    DOCKER_CONTAINER_ORB: {
        radius: 150,
        textColor: 0xf0f0f0,
        textOutlineColor: 0xf0f0f0,
        defaultLayerScaleFactor: 0.08,
        // 👇 Image config: mirrors DESMOS_ORB pattern
        imageUrlPath: "IconURL",
        imageMaskStyle: "roundedSquare",
        imageSize: 256,
        imageRadius: 28,
        imageSpriteScale: 140,
        imageColor: 0xf0f0f0,
        layers: [
            { shape: 'cube', color: 0x3496d3 },
            { shape: 'cube', color: 0xf0f0f0 },
            { shape: 'sphere', color: 0x1D63ED },
            { shape: 'sphere', color: 0xf0f0f0 },
        ],
        connectionProfiles: [
            {
                label: 'Connect Containers to Endpoints',
                toType: 'CONTAINER_ENDPOINT_ORB',
                // container JSON
                buildSourceKey: (d) => { var _a; return ((_a = d === null || d === void 0 ? void 0 : d.FullAddress) !== null && _a !== void 0 ? _a : '').toLowerCase(); },
                // endpoint JSON: ContainerMetadata.Port (e.g. "10.0.0.16:3001")
                buildTargetKey: (d) => {
                    var _a, _b;
                    const v = ((_b = (_a = d === null || d === void 0 ? void 0 : d.ContainerMetadata) === null || _a === void 0 ? void 0 : _a.Port) !== null && _b !== void 0 ? _b : '').toLowerCase();
                    return v || undefined;
                },
                // distinct green style matching endpoint theme
                edgeProfile: {
                    style: {
                        color: 0x84EC2C,
                        widthPx: 12,
                        distanceStyle: {
                            widthPx: { near: 200, far: 2400, min: 1, max: 5 }
                        }
                    },
                    arrows: { start: false, end: true, size: 10 },
                    curve: { mode: 'straight', bend: 0.18, segments: 20 },
                    // Make it slow and gentle:
                    elastic: {
                        enabled: true,
                        rest: 900,
                        stiffness: 2,
                        damping: 6,
                        transverseDamping: 4,
                        maxForce: 10,
                        // NEW: make it extra gentle & only move endpoints
                        impulseScale: 0.25,
                        applyTo: 'b',
                        maxSpeed: 6,
                        deadband: 5,
                        minSeparation: 700,
                        minRestLength: 0,
                        siblingRepulsion: {
                            enabled: true,
                            root: 'a',
                            radius: 'rest',
                            k: 0.06,
                            cutoffAngle: Math.PI / 12,
                            deadbandAngle: Math.PI / 48,
                            maxNeighbors: 6,
                            cooldownFrames: 20,
                        }
                    }
                }
            }
        ]
    },
    CONTAINER_IMAGE_ORB: {
        radius: 150,
        textColor: 0xf0f0f0,
        textOutlineColor: 0xf0f0f0,
        defaultLayerScaleFactor: 0.08,
        layers: [
            { shape: 'cube', color: 0x262262 },
            { shape: 'cube', color: 0x808285 },
            { shape: 'sphere', color: 0x5f5fbb },
            { shape: 'sphere', color: 0x262262 },
        ],
        connectionProfiles: [
            {
                label: 'Connect Registry to Containers',
                toType: 'DOCKER_CONTAINER_ORB',
                buildSourceKey: (d) => {
                    var _a, _b;
                    const name = ((_a = d === null || d === void 0 ? void 0 : d.imageName) !== null && _a !== void 0 ? _a : '').toLowerCase();
                    const displayName = ((_b = d === null || d === void 0 ? void 0 : d.displayName) !== null && _b !== void 0 ? _b : '').toLowerCase();
                    if (!name || !(displayName.split(':').pop() === 'latest'))
                        return undefined;
                    return name;
                },
                buildTargetKey: (d) => { var _a, _b; return ((_b = (_a = d === null || d === void 0 ? void 0 : d.BaseName) !== null && _a !== void 0 ? _a : d === null || d === void 0 ? void 0 : d.baseName) !== null && _b !== void 0 ? _b : '').toLowerCase() || undefined; },
                edgeProfile: {
                    style: {
                        color: 0x262262,
                        widthPx: 3,
                        distanceStyle: {
                            widthPx: { near: 200, far: 2400, min: 1, max: 5 }
                        }
                    },
                    arrows: { start: false, end: true, size: 10 },
                    curve: { mode: 'straight', bend: 0.18, segments: 20 },
                    elastic: {
                        enabled: true,
                        rest: 1300,
                        stiffness: 2,
                        damping: 6,
                        transverseDamping: 4,
                        maxForce: 10,
                        // NEW: make it extra gentle & only move endpoints
                        impulseScale: 0.25,
                        applyTo: 'b',
                        maxSpeed: 6,
                        deadband: 5,
                        minSeparation: 1100,
                        minRestLength: 0
                    }
                }
            }
        ],
    },
    //DOCKER_SWARM_ORB: genLangOrb(0x2d3ec3, 0xc1c6d3), //New, will be used in place of kubernetes node
    DOCKER_SWARM_ORB: Object.assign({}, genLangOrb(0x2d3ec3, 0xc1c6d3)),
    //KUBERNETES_ORB: genLangOrb(0xFCC41C, 0x3069de),
    CONTAINER_ENDPOINT_ORB: Object.assign(Object.assign({}, genLangOrb(0x84EC2C, 0x173647)), { connectionProfiles: [
            {
                label: 'Connect endpoitns to certain functions',
                toType: 'LANGUAGE_ORB',
                buildSourceKey: (d) => {
                    var _a, _b;
                    const name = ((_a = d === null || d === void 0 ? void 0 : d.imageName) !== null && _a !== void 0 ? _a : '').toLowerCase();
                    const displayName = ((_b = d === null || d === void 0 ? void 0 : d.displayName) !== null && _b !== void 0 ? _b : '').toLowerCase();
                    if (!name || !(displayName.split(':').pop() === 'latest'))
                        return undefined;
                    return name;
                },
                buildTargetKey: (d) => { var _a, _b; return ((_b = (_a = d === null || d === void 0 ? void 0 : d.BaseName) !== null && _a !== void 0 ? _a : d === null || d === void 0 ? void 0 : d.baseName) !== null && _b !== void 0 ? _b : '').toLowerCase() || undefined; },
                edgeProfile: {
                    style: {
                        color: 0x262262,
                        widthPx: 3,
                        distanceStyle: {
                            widthPx: { near: 200, far: 2400, min: 1, max: 5 }
                        }
                    },
                    arrows: { start: false, end: true, size: 10 },
                    curve: { mode: 'straight', bend: 0.18, segments: 20 },
                    elastic: {
                        enabled: true,
                        rest: 1300,
                        stiffness: 2,
                        damping: 6,
                        transverseDamping: 4,
                        maxForce: 10,
                        // NEW: make it extra gentle & only move endpoints
                        impulseScale: 0.25,
                        applyTo: 'b',
                        maxSpeed: 6,
                        deadband: 5,
                        minSeparation: 1100,
                        minRestLength: 0,
                        siblingRepulsion: {
                            enabled: true,
                            root: 'a',
                            radius: 'rest',
                            k: 0.06,
                            cutoffAngle: Math.PI / 12,
                            deadbandAngle: Math.PI / 48,
                            maxNeighbors: 6,
                            cooldownFrames: 20,
                        }
                    }
                }
            }
        ] }),
    //COMPUTER_ORB: genLangOrb(0x2d3ec3, 0xc1c6d3),
    COMPUTER_ORB: {
        radius: 150,
        textColor: 0xf0f0f0,
        textOutlineColor: 0xf0f0f0,
        defaultLayerScaleFactor: 0.08,
        layers: [
            { shape: 'cube', color: 0x2d3ec3 },
            { shape: 'cube', color: 0xc1c6d3 },
            { shape: 'sphere', color: 0x9ca3db },
            { shape: 'sphere', color: 0x2d3ec3 },
        ],
        connectionProfiles: [
            {
                label: 'Connect Swarm to Containers',
                toType: 'DOCKER_CONTAINER_ORB',
                // both sides on Hostname (lowercased). If a side lacks Hostname, it just won’t connect.
                //buildSourceKey: (d: any) => (d?.Hostname ?? '').toLowerCase() || undefined,
                buildSourceKey: (d) => {
                    var _a;
                    const name = ((_a = d === null || d === void 0 ? void 0 : d.Hostname) !== null && _a !== void 0 ? _a : '').toLowerCase();
                    console.log('Swarm→Container lookup key:', name);
                    return name;
                },
                //buildTargetKey: (d: any) => (d?.HostName ?? '').toLowerCase() || undefined,
                buildTargetKey: (d) => {
                    var _a;
                    const name = ((_a = d === null || d === void 0 ? void 0 : d.HostName) !== null && _a !== void 0 ? _a : '').toLowerCase();
                    console.log('Swarm→Container target key:', name);
                    return name;
                },
                // distinct infra-blue style, dashed
                edgeProfile: {
                    style: {
                        color: 0x3496d3,
                        widthPx: 2,
                        dashed: true,
                        dashScale: 1.2
                    },
                    arrows: { start: false, end: true, size: 10 },
                    curve: { mode: 'straight', segments: 12 },
                    elastic: {
                        enabled: true,
                        rest: 2300,
                        stiffness: 2,
                        damping: 6,
                        transverseDamping: 4,
                        maxForce: 10,
                        // NEW: make it extra gentle & only move endpoints
                        impulseScale: 0.25,
                        applyTo: 'b',
                        maxSpeed: 6,
                        deadband: 5,
                        minSeparation: 2000,
                        minRestLength: 0
                    }
                }
            }
        ]
    },
    PROMPT_ORB: genLangOrb(0x18ed86, 0xf0f0f0),
    PROMPT_RESPONSE_ORB: genLangOrb(0xFF00FF, 0xf0f0f0),
    //CHATBOT_ORB: genLangOrb(0xda27e2, 0xf0f0f0),
    CHATBOT_ORB: {
        radius: 150,
        textColor: 0xf0f0f0,
        textOutlineColor: 0xf0f0f0,
        defaultLayerScaleFactor: 0.08,
        layers: [
            { shape: 'tetrahedron', color: 0xda27e2, rotationSpeed: new THREE.Vector3(0.005, 0.005, 0.005) },
            { shape: 'tetrahedron', color: 0xf0f0f0, rotationSpeed: new THREE.Vector3(0.005, 0.005, 0.005) },
            { shape: 'sphere', color: 0xdf86e3 },
            { shape: 'sphere', color: 0xf0f0f0 },
        ],
        edgeProfiles: {
            elasticCurve: {
                style: {
                    color: 0x9c27b0,
                    widthPx: 3,
                    opacity: 0.9,
                    distanceStyle: {
                        widthPx: { near: 200, far: 2000, min: 1, max: 5 }
                        // opacity: { near: 200, far: 2000, min: 0.5, max: 1.0 } // optional
                    }
                },
                curve: { mode: 'quadratic', bend: 0.3, segments: 20 },
                arrows: { end: true, size: 10 },
                elastic: { enabled: true, rest: 'surface', stiffness: 8, damping: 2 }
            }
        },
        defaultEdgeProfile: 'elasticCurve',
        actions: [
            {
                trigger: 'onActivate',
                kind: 'connectOrbs',
                options: {
                    left: { byType: 'BLACKHOLE' },
                    right: { fetcher: 'githubOrbs', args: {} },
                    cartesian: false,
                    connectionType: 'edge',
                    profileName: 'elasticCurve',
                    profile: { label: { text: '@data.repoName', atT: 0.55, spriteScale: 28 } }
                }
            }
        ]
    },
    DOMAIN_ORB: {
        radius: languageOrbSizes,
        textColor: 0xf0f0f0,
        defaultLayerScaleFactor: 0.08,
        layers: [
            { shape: 'sphere', color: 0xf48120 },
            { shape: 'sphere', color: 0xf0f0f0 }, //alt orange 0xfaad3f
        ],
        connectionProfiles: [
            // Apex → all records in the same zone (except itself)
            {
                label: 'Connect Domains to Domains',
                toType: 'DOMAIN_ORB',
                buildSourceKey: (d) => {
                    const name = lc(d === null || d === void 0 ? void 0 : d.name);
                    const zone = lc(d === null || d === void 0 ? void 0 : d.zone);
                    // only apex (name === zone) acts as the source “hub”
                    return name && zone && name === zone ? zone : undefined;
                },
                buildTargetKey: (d) => {
                    const name = lc(d === null || d === void 0 ? void 0 : d.name);
                    const zone = lc(d === null || d === void 0 ? void 0 : d.zone);
                    // any record in the same zone, but not the apex itself
                    if (!zone || !name)
                        return undefined;
                    return name !== zone ? zone : undefined;
                },
                edgeProfile: {
                    style: { color: 0xf48120, widthPx: 2 },
                    arrows: { start: false, end: true, size: 8 },
                    curve: { mode: 'straight', segments: 12 },
                    elastic: {
                        enabled: true, rest: 1800, stiffness: 2, damping: 6,
                        impulseScale: 0.2, applyTo: 'b', maxSpeed: 6, deadband: 5,
                        minSeparation: 1200
                    }
                }
            },
            // Domains → Gateways (exact name match)
            {
                label: 'Connect Domains to Network Gatways',
                toType: 'NETWORK_GATEWAY_ORB',
                buildSourceKey: (d) => lc(d === null || d === void 0 ? void 0 : d.name) || undefined,
                buildTargetKey: (g) => gatewayDomain(g) || undefined,
                edgeProfile: {
                    style: { color: 0x8ecae6, widthPx: 2 },
                    arrows: { start: false, end: true, size: 8 },
                    curve: { mode: 'straight', segments: 12 },
                    elastic: {
                        enabled: true, rest: 2000, stiffness: 2, damping: 6,
                        impulseScale: 0.2, applyTo: 'b', maxSpeed: 6, deadband: 5,
                        minSeparation: 1400
                    }
                }
            }
        ],
    },
    SYSTEM_ORB: {
        radius: 500,
        textColor: 0x713cfd,
        textOutlineColor: 0x1c3eed,
        defaultLayerScaleFactor: 0.08,
        layers: [
            // Inner layer is the portal “window”
            { shape: 'sphere', color: 0xDFE9F0, portalSurface: true },
            // Outer shell stays as your visible rim
            { shape: 'sphere', color: 0x2596BE }
        ],
    },
    SYSTEM_ORB_SINGLE: {
        radius: 500,
        textColor: 0x713cfd,
        textOutlineColor: 0x1c3eed,
        defaultLayerScaleFactor: 0.08,
        layers: [
            { shape: 'sphere', color: 0xDFE9F0, portalSurface: true }
        ],
    },
    AI_AGENT_ORB: genLangOrb(0x2596BE, 0xf0f0f0),
    SYSTEM_WILL_ORB: genLangOrb(0xf5ff00, 0xfab500, 0xf1840b),
    TEXT_INFO_ORB: genLangOrb(0x27ccbb, 0x7F87F8),
    TEXT_OBJECT_ORB: {
        radius: languageOrbSizes,
        textColor: 0xf0f0f0,
        defaultLayerScaleFactor: 0.08,
        layers: [
            { shape: 'sphere', color: 0x27ccbb },
            { shape: 'sphere', color: 0x7F87F8 },
        ],
        connectionProfiles: [
            // Linear sequence (next)
            {
                label: 'Connect Text Objects to Text Objects',
                toType: 'TEXT_OBJECT_ORB',
                buildSourceKey: (t) => lc(t === null || t === void 0 ? void 0 : t.id) || undefined,
                buildTargetKey: (t) => lc(t === null || t === void 0 ? void 0 : t.prev_id) || undefined,
                edgeProfile: {
                    style: { color: 0x27ccbb, widthPx: 2 },
                    arrows: { start: false, end: true, size: 8 },
                    curve: { mode: 'straight', segments: 10 },
                    elastic: {
                        enabled: true, rest: 900, stiffness: 2, damping: 6,
                        impulseScale: 0.18, applyTo: 'b', maxSpeed: 6, deadband: 5,
                        minSeparation: 700
                    }
                }
            },
            // Graph edges (outgoingNodes contains IDs)
            {
                label: 'Connect Text Objects to Text Objects (graph)',
                toType: 'TEXT_OBJECT_ORB',
                buildSourceKey: (t) => {
                    var _a;
                    const id = lc(t === null || t === void 0 ? void 0 : t.id);
                    const outs = ((_a = t === null || t === void 0 ? void 0 : t.outgoingNodes) !== null && _a !== void 0 ? _a : []).map((x) => lc(x)).filter(Boolean);
                    // emit one key per outgoing edge: we encode as `id::target`
                    // Explorer will try all pairs; if your engine expects 1:1 keys,
                    // you can expand these records beforehand.
                    return outs.length ? outs.map((tid) => `${id}::${tid}`) : undefined;
                },
                buildTargetKey: (t) => {
                    // accept either exact id (for direct match) or id embedded in pair
                    const id = lc(t === null || t === void 0 ? void 0 : t.id);
                    return id ? [`${id}`, `::${id}`] : undefined;
                },
                edgeProfile: {
                    style: { color: 0x7F87F8, widthPx: 1.5, dashed: true, dashScale: 1.1 },
                    arrows: { start: false, end: true, size: 7 },
                    curve: { mode: 'straight', segments: 10 },
                    elastic: {
                        enabled: true, rest: 1000, stiffness: 2, damping: 6,
                        impulseScale: 0.18, applyTo: 'b', maxSpeed: 6, deadband: 5,
                        minSeparation: 700
                    }
                }
            }
        ],
    },
    DATABASE_OBJECT_ORB: {
        radius: languageOrbSizes,
        textColor: 0xf0f0f0,
        defaultLayerScaleFactor: 0.08,
        layers: [
            { shape: 'sphere', color: 0xff2cff },
            { shape: 'sphere', color: 0x2428ff },
        ],
    },
    NETWORK_GATEWAY_ORB: {
        radius: languageOrbSizes,
        textColor: 0xf0f0f0,
        defaultLayerScaleFactor: 0.08,
        layers: [
            { shape: 'sphere', color: 0x1a0081 },
            { shape: 'sphere', color: 0x00d084 }, // #b1eb1f (green), #00d084 (alt green) // ORGINAL #009900
        ],
        connectionProfiles: [
            // Root gateway → child routes (uses parentId)
            {
                label: 'Connect Network Gatways to Network Gatways',
                toType: 'NETWORK_GATEWAY_ORB',
                // source: any root leaf for a domain (path “/”, or name == domain)
                buildSourceKey: (g) => {
                    if (!isGatewayRoot(g))
                        return undefined;
                    // key by our own id; children will point to parentId
                    return lc(g === null || g === void 0 ? void 0 : g.id);
                },
                buildTargetKey: (g) => {
                    const parentId = lc(g === null || g === void 0 ? void 0 : g.parentId);
                    return parentId || undefined;
                },
                edgeProfile: {
                    style: { color: 0x55d6a8, widthPx: 3 },
                    arrows: { start: false, end: true, size: 10 },
                    curve: { mode: 'straight', segments: 16 },
                    elastic: {
                        enabled: true, rest: 1200, stiffness: 2, damping: 6,
                        impulseScale: 0.25, applyTo: 'b', maxSpeed: 6, deadband: 5,
                        minSeparation: 1100
                    }
                }
            },
            // (optional) Same vhost clustering: connect the root to all siblings via vhostId
            {
                label: 'Cluster vhost members',
                toType: 'NETWORK_GATEWAY_ORB',
                buildSourceKey: (g) => {
                    // only root acts as the cluster hub
                    if (!isGatewayRoot(g))
                        return undefined;
                    return `vhost:${lc(g === null || g === void 0 ? void 0 : g.vhostId)}`;
                },
                buildTargetKey: (g) => {
                    const vid = lc(g === null || g === void 0 ? void 0 : g.vhostId);
                    return vid ? `vhost:${vid}` : undefined;
                },
                edgeProfile: {
                    style: { color: 0x226622, widthPx: 1.5, dashed: true, dashScale: 1.1 },
                    arrows: { start: false, end: true },
                    curve: { mode: 'straight', segments: 10 },
                    elastic: {
                        enabled: true, rest: 2000, stiffness: 2, damping: 6,
                        impulseScale: 0.2, applyTo: 'b', maxSpeed: 6, deadband: 5,
                        minSeparation: 1400
                    }
                }
            },
            {
                label: 'Connect Network Gatways to Endpoints',
                toType: 'CONTAINER_ENDPOINT_ORB',
                buildSourceKey: (g) => {
                    // use backend host:port + backendPath (not the public path)
                    const k = hostPortPathKey(g === null || g === void 0 ? void 0 : g.backendHost, g === null || g === void 0 ? void 0 : g.backendPort, g === null || g === void 0 ? void 0 : g.backendPath);
                    return k || undefined; // e.g. "10.0.0.16:3001/AllSystemRepositories"
                },
                buildTargetKey: (ep) => {
                    var _a;
                    // data shape from your example (ContainerMetadata.Port + Path)
                    const port = lc((_a = ep === null || ep === void 0 ? void 0 : ep.ContainerMetadata) === null || _a === void 0 ? void 0 : _a.Port); // already "10.0.0.16:3001"
                    const path = ep === null || ep === void 0 ? void 0 : ep.Path; // "/AllSystemRepositories"
                    const k = hostPortPathKey(port === null || port === void 0 ? void 0 : port.split(':')[0], port === null || port === void 0 ? void 0 : port.split(':')[1], path);
                    return k || undefined;
                },
                edgeProfile: {
                    style: { color: 0x009900, widthPx: 2 },
                    arrows: { start: false, end: true, size: 9 },
                    curve: { mode: 'straight', segments: 14 },
                    elastic: {
                        enabled: true, rest: 1600, stiffness: 2, damping: 6,
                        impulseScale: 0.22, applyTo: 'b', maxSpeed: 6, deadband: 5,
                        minSeparation: 1200
                    }
                }
            }
        ],
    },
    SHAPE_TEST_TETRAHEDRON: {
        radius: 150,
        textColor: 0xffffff,
        defaultLayerScaleFactor: 0.15,
        layers: [
            { shape: 'tetrahedron', color: 0xff0000, rotationSpeed: new THREE.Vector3(0.01, 0.02, 0.03) },
            { shape: 'sphere', color: 0x333333 },
            { shape: 'sphere', color: 0xf0f0f0 },
        ],
    },
    SHAPE_TEST_CUBE: {
        radius: 150,
        textColor: 0xffffff,
        defaultLayerScaleFactor: 0.15,
        layers: [
            { shape: 'cube', color: 0x00ff00, rotationSpeed: new THREE.Vector3(0.02, 0.01, 0.03) },
            { shape: 'sphere', color: 0x333333 },
            { shape: 'sphere', color: 0xf0f0f0 },
        ],
    },
    SHAPE_TEST_OCTAHEDRON: {
        radius: 150,
        textColor: 0xffffff,
        defaultLayerScaleFactor: 0.15,
        layers: [
            { shape: 'octahedron', color: 0x0000ff, rotationSpeed: new THREE.Vector3(0.03, 0.02, 0.01) },
            { shape: 'sphere', color: 0x333333 },
            { shape: 'sphere', color: 0xf0f0f0 },
        ],
    },
    SHAPE_TEST_DODECAHEDRON: {
        radius: 150,
        textColor: 0xffffff,
        defaultLayerScaleFactor: 0.15,
        layers: [
            { shape: 'dodecahedron', color: 0xffff00, rotationSpeed: new THREE.Vector3(0.01, 0.03, 0.02) },
            { shape: 'sphere', color: 0x333333 },
            { shape: 'sphere', color: 0xf0f0f0 },
        ],
    },
    SHAPE_TEST_ICOSAHEDRON: {
        radius: 150,
        textColor: 0xffffff,
        defaultLayerScaleFactor: 0.15,
        layers: [
            { shape: 'icosahedron', color: 0xff00ff, rotationSpeed: new THREE.Vector3(0.02, 0.03, 0.01) },
            { shape: 'sphere', color: 0x333333 },
            { shape: 'sphere', color: 0xf0f0f0 },
        ],
    },
    SHAPE_TEST_DOUBLE_TETRAHEDRON: {
        radius: 150,
        textColor: 0xffffff,
        defaultLayerScaleFactor: 0.15,
        layers: [
            { shape: 'tetrahedron', color: 0xff0000, rotationSpeed: new THREE.Vector3(0.01, 0.02, 0.03) },
            { shape: 'tetrahedron', color: 0xffffff, rotationSpeed: new THREE.Vector3(0.01, 0.02, 0.03) },
        ],
    },
    SHAPE_TEST_DOUBLE_CUBE: {
        radius: 150,
        textColor: 0xffffff,
        defaultLayerScaleFactor: 0.15,
        layers: [
            { shape: 'cube', color: 0x00ff00, rotationSpeed: new THREE.Vector3(0.02, 0.01, 0.03) },
            { shape: 'cube', color: 0xffffff, rotationSpeed: new THREE.Vector3(0.02, 0.01, 0.03) },
        ],
    },
    SHAPE_TEST_DOUBLE_OCTAHEDRON: {
        radius: 150,
        textColor: 0xffffff,
        defaultLayerScaleFactor: 0.15,
        layers: [
            { shape: 'octahedron', color: 0x0000ff, rotationSpeed: new THREE.Vector3(0.03, 0.02, 0.01) },
            { shape: 'octahedron', color: 0xffffff, rotationSpeed: new THREE.Vector3(0.03, 0.02, 0.01) },
        ],
    },
    SHAPE_TEST_DOUBLE_DODECAHEDRON: {
        radius: 150,
        textColor: 0xffffff,
        defaultLayerScaleFactor: 0.15,
        layers: [
            { shape: 'dodecahedron', color: 0xffff00, rotationSpeed: new THREE.Vector3(0.01, 0.03, 0.02) },
            { shape: 'dodecahedron', color: 0xffffff, rotationSpeed: new THREE.Vector3(0.01, 0.03, 0.02) },
        ],
    },
    SHAPE_TEST_DOUBLE_ICOSAHEDRON: {
        radius: 150,
        textColor: 0xffffff,
        defaultLayerScaleFactor: 0.15,
        layers: [
            { shape: 'icosahedron', color: 0xff00ff, rotationSpeed: new THREE.Vector3(0.02, 0.03, 0.01) },
            { shape: 'icosahedron', color: 0xffffff, rotationSpeed: new THREE.Vector3(0.02, 0.03, 0.01) },
        ],
    },
    // --- ABSTRACT ALGEBRA NEST -------------------------------------------------
    // Group ⊃ Abelian Group ⊃ Ring ⊃ Field ⊃ Vector Space
    GROUP_ORB: {
        orbType: 'GROUP_ORB',
        radius: 600,
        textColor: 0xffffff,
        defaultLayerScaleFactor: 0.08,
        layoutMode: 'rootContainer',
        containmentLayout: {
            enabled: true,
            mode: 'concentric',
            children: [
                {
                    orbType: 'ABELIAN_GROUP_ORB',
                    label: 'Abelian Group',
                    relativeRadiusRatio: 0.8,
                    placement: 'center',
                    children: [
                        {
                            orbType: 'RING_ORB',
                            label: 'Ring',
                            relativeRadiusRatio: 0.6,
                            placement: 'center',
                            children: [
                                {
                                    orbType: 'FIELD_ORB',
                                    label: 'Field',
                                    relativeRadiusRatio: 0.45,
                                    placement: 'center',
                                    children: [
                                        {
                                            orbType: 'VECTOR_SPACE_ORB',
                                            label: 'Vector Space',
                                            relativeRadiusRatio: 0.3,
                                            placement: 'center',
                                            children: []
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        layers: [
            { shape: 'sphere', color: 0x2244aa, side: THREE.BackSide },
            { shape: 'sphere', color: 0x88bbff, side: THREE.BackSide },
        ],
        textCanvasScale: 2,
        textFont: '64px Times New Roman',
    },
    ABELIAN_GROUP_ORB: {
        orbType: 'ABELIAN_GROUP_ORB',
        radius: 680,
        textColor: 0xffffff,
        layoutMode: 'containedChild',
        defaultLayerScaleFactor: 0.08,
        layers: [
            { shape: 'sphere', color: 0x3366cc, side: THREE.BackSide },
            { shape: 'sphere', color: 0xaad0ff, side: THREE.BackSide },
        ],
        textCanvasScale: 2,
        textFont: '60px Times New Roman',
    },
    RING_ORB: {
        orbType: 'RING_ORB',
        radius: 460,
        textColor: 0xffffff,
        layoutMode: 'containedChild',
        defaultLayerScaleFactor: 0.08,
        layers: [
            { shape: 'sphere', color: 0x338899, side: THREE.BackSide },
            { shape: 'sphere', color: 0x88f0ff, side: THREE.BackSide },
        ],
        textCanvasScale: 2,
        textFont: '60px Times New Roman',
    },
    FIELD_ORB: {
        orbType: 'FIELD_ORB',
        radius: 360,
        textColor: 0xffffff,
        layoutMode: 'containedChild',
        defaultLayerScaleFactor: 0.08,
        layers: [
            { shape: 'sphere', color: 0x33aa88, side: THREE.BackSide },
            { shape: 'sphere', color: 0x88ffdd, side: THREE.BackSide },
        ],
        textCanvasScale: 2,
        textFont: '60px Times New Roman',
    },
    VECTOR_SPACE_ORB: {
        orbType: 'VECTOR_SPACE_ORB',
        radius: 280,
        textColor: 0xffffff,
        layoutMode: 'containedChild',
        defaultLayerScaleFactor: 0.08,
        layers: [
            { shape: 'sphere', color: 0x33cc66, side: THREE.BackSide },
            { shape: 'sphere', color: 0xaaffcc, side: THREE.BackSide },
        ],
        textCanvasScale: 2,
        textFont: '60px Times New Roman',
    },
    // ---------------------------------------------------------------------------
    // --- NUMBER SYSTEM NEST ----------------------------------------------------
    // ℝ ⊃ ℚ ⊃ ℤ ⊃ ℕ, plus "irrationals" as sibling inside ℝ but NOT inside ℚ
    REAL_NUMBER_ORB: {
        orbType: 'REAL_NUMBER_ORB',
        radius: 600,
        textColor: 0xffffff,
        layoutMode: 'rootContainer',
        defaultLayerScaleFactor: 0.08,
        containmentLayout: {
            enabled: true,
            mode: 'packed',
            children: [
                {
                    orbType: 'RATIONAL_NUMBER_ORB',
                    label: 'ℚ rationals',
                    relativeRadiusRatio: 0.7,
                    placement: 'custom',
                    offset: new THREE.Vector3(-80, 0, -40),
                    children: [
                        {
                            orbType: 'INTEGER_NUMBER_ORB',
                            label: 'ℤ integers',
                            relativeRadiusRatio: 0.5,
                            placement: 'custom',
                            offset: new THREE.Vector3(-140, 0, -80),
                            children: [
                                {
                                    orbType: 'NATURAL_NUMBER_ORB',
                                    label: 'ℕ naturals',
                                    relativeRadiusRatio: 0.33,
                                    placement: 'custom',
                                    offset: new THREE.Vector3(-190, 0, -120),
                                    children: []
                                }
                            ]
                        }
                    ]
                },
                {
                    // "irrationals" = ℝ \ ℚ, conceptual sibling of ℚ inside ℝ
                    orbType: 'IRRATIONAL_NUMBER_REGION_ORB',
                    label: 'irrationals',
                    relativeRadiusRatio: 0.43,
                    placement: 'custom',
                    offset: new THREE.Vector3(160, 0, 120),
                    children: []
                }
            ]
        },
        layers: [
            { shape: 'sphere', color: 0x552277, side: THREE.BackSide },
            { shape: 'sphere', color: 0xcc88ff, side: THREE.BackSide },
        ],
        textCanvasScale: 2,
        textFont: '64px Times New Roman',
    },
    RATIONAL_NUMBER_ORB: {
        orbType: 'RATIONAL_NUMBER_ORB',
        radius: 420,
        textColor: 0xffffff,
        layoutMode: 'containedChild',
        defaultLayerScaleFactor: 0.08,
        layers: [
            { shape: 'sphere', color: 0x773399, side: THREE.BackSide },
            { shape: 'sphere', color: 0xeeaaff, side: THREE.BackSide },
        ],
        textFont: '60px Times New Roman',
    },
    INTEGER_NUMBER_ORB: {
        orbType: 'INTEGER_NUMBER_ORB',
        radius: 300,
        textColor: 0xffffff,
        layoutMode: 'containedChild',
        defaultLayerScaleFactor: 0.08,
        layers: [
            { shape: 'sphere', color: 0x9955aa, side: THREE.BackSide },
            { shape: 'sphere', color: 0xffbbff, side: THREE.BackSide },
        ],
        textFont: '60px Times New Roman',
    },
    NATURAL_NUMBER_ORB: {
        orbType: 'NATURAL_NUMBER_ORB',
        radius: 200,
        textColor: 0xffffff,
        layoutMode: 'containedChild',
        defaultLayerScaleFactor: 0.08,
        layers: [
            { shape: 'sphere', color: 0xbb77cc, side: THREE.BackSide },
            { shape: 'sphere', color: 0xffddff, side: THREE.BackSide },
        ],
        textFont: '60px Times New Roman',
    },
    IRRATIONAL_NUMBER_REGION_ORB: {
        orbType: 'IRRATIONAL_NUMBER_REGION_ORB',
        radius: 260,
        textColor: 0xffffff,
        layoutMode: 'containedChild',
        defaultLayerScaleFactor: 0.08,
        layers: [
            { shape: 'sphere', color: 0x331144, side: THREE.BackSide },
            { shape: 'sphere', color: 0xaa77ff, side: THREE.BackSide },
        ],
        textFont: '60px Times New Roman',
    },
    // ---------------------------------------------------------------------------
    // --- ANALYSIS / FUNCTION REGULARITY NEST -----------------------------------
    // Continuous → Measurable → Integrable, and "Differentiable ⇒ Continuous"
    ANALYSIS_REGULARITY_ORB: {
        orbType: 'ANALYSIS_REGULARITY_ORB',
        radius: 260,
        textColor: 0xffffff,
        layoutMode: 'rootContainer',
        defaultLayerScaleFactor: 0.08,
        containmentLayout: {
            enabled: true,
            mode: 'planes',
            children: [
                {
                    orbType: 'DIFFERENTIABLE_FUNCTIONS_ORB',
                    label: 'Differentiable',
                    relativeRadiusRatio: 1.0,
                    placement: 'custom',
                    offset: new THREE.Vector3(-200, 180, 0),
                    children: []
                },
                {
                    orbType: 'CONTINUOUS_FUNCTIONS_ORB',
                    label: 'Continuous',
                    relativeRadiusRatio: 1.0,
                    placement: 'custom',
                    offset: new THREE.Vector3(-200, 0, 0),
                    children: [
                        {
                            orbType: 'MEASURABLE_FUNCTIONS_ORB',
                            label: 'Measurable',
                            relativeRadiusRatio: 1.0,
                            placement: 'custom',
                            offset: new THREE.Vector3(0, 0, 0),
                            children: [
                                {
                                    orbType: 'INTEGRABLE_FUNCTIONS_ORB',
                                    label: 'Integrable',
                                    relativeRadiusRatio: 1.0,
                                    placement: 'custom',
                                    offset: new THREE.Vector3(200, 0, 0),
                                    children: []
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        layers: [
            { shape: 'sphere', color: 0x112244, side: THREE.BackSide },
            { shape: 'sphere', color: 0x4477ff, side: THREE.BackSide },
        ],
        textFont: '60px Times New Roman',
    },
    DIFFERENTIABLE_FUNCTIONS_ORB: {
        orbType: 'DIFFERENTIABLE_FUNCTIONS_ORB',
        radius: 220,
        textColor: 0xffffff,
        layoutMode: 'containedChild',
        layers: [
            { shape: 'sphere', color: 0x114455, side: THREE.BackSide },
            { shape: 'sphere', color: 0x66ccff, side: THREE.BackSide },
        ],
        textFont: '48px Times New Roman',
    },
    CONTINUOUS_FUNCTIONS_ORB: {
        orbType: 'CONTINUOUS_FUNCTIONS_ORB',
        radius: 220,
        textColor: 0xffffff,
        layoutMode: 'containedChild',
        layers: [
            { shape: 'sphere', color: 0x114455, side: THREE.BackSide },
            { shape: 'sphere', color: 0x66ccff, side: THREE.BackSide },
        ],
        textFont: '48px Times New Roman',
    },
    MEASURABLE_FUNCTIONS_ORB: {
        orbType: 'MEASURABLE_FUNCTIONS_ORB',
        radius: 220,
        textColor: 0xffffff,
        layoutMode: 'containedChild',
        layers: [
            { shape: 'sphere', color: 0x113355, side: THREE.BackSide },
            { shape: 'sphere', color: 0x55aaff, side: THREE.BackSide },
        ],
        textFont: '48px Times New Roman',
    },
    INTEGRABLE_FUNCTIONS_ORB: {
        orbType: 'INTEGRABLE_FUNCTIONS_ORB',
        radius: 220,
        textColor: 0xffffff,
        layoutMode: 'containedChild',
        layers: [
            { shape: 'sphere', color: 0x112244, side: THREE.BackSide },
            { shape: 'sphere', color: 0x4477ff, side: THREE.BackSide },
        ],
        textFont: '48px Times New Roman',
    },
};
// Helper to simplify language-based 2-layer orbs
function genLangOrb(...colors) {
    return {
        radius: languageOrbSizes,
        textColor: 0xffffff,
        defaultLayerScaleFactor: 0.08,
        layers: colors.map((color, i) => ({
            shape: 'sphere',
            color,
            scaleFactor: i === 0 ? 1.0 : undefined,
        })),
    };
}
// Helpers for connection logic
const lc = (s) => (s !== null && s !== void 0 ? s : '').toLowerCase().trim();
const csvToList = (csv) => lc(csv).split(',').map(s => s.trim()).filter(Boolean);
// prefer an explicit gateway field, fall back to parsing `name`
const gatewayDomain = (g) => {
    const src = lc(g === null || g === void 0 ? void 0 : g.sourceDomain);
    if (src)
        return src;
    const firstServerName = csvToList(g === null || g === void 0 ? void 0 : g.serverNameCsv)[0];
    if (firstServerName)
        return firstServerName;
    // fallback: name like "api.orbscape.io/chatbots" → "api.orbscape.io"
    const n = lc(g === null || g === void 0 ? void 0 : g.name);
    return n.includes('/') ? n.split('/')[0] : n;
};
// host:port + path (for Gateway→Endpoint matches)
const hostPortPathKey = (host, port, path) => {
    const h = lc(host);
    const p = (port !== null && port !== void 0 ? port : '').toString().trim();
    const raw = `${h}${p ? `:${p}` : ''}${(path === null || path === void 0 ? void 0 : path.startsWith('/')) ? path : `/${path !== null && path !== void 0 ? path : ''}`}`;
    return raw.replace(/\/+/g, '/'); // normalize accidental doubles
};
// true if object looks like a ROOT gateway leaf (the “parent”)
const isGatewayRoot = (g) => ((g === null || g === void 0 ? void 0 : g.path) === '/' || lc(g === null || g === void 0 ? void 0 : g.name) === gatewayDomain(g));
function lower(s) { return (s !== null && s !== void 0 ? s : "").toLowerCase(); }
function val(data, ...paths) {
    // grab first present field path (supports "a.b.c" or flat "short_commit_hash")
    for (const p of paths) {
        const parts = p.split(".");
        let cur = data;
        let ok = true;
        for (const k of parts) {
            if (cur && Object.prototype.hasOwnProperty.call(cur, k)) {
                cur = cur[k];
            }
            else {
                ok = false;
                break;
            }
        }
        if (ok && typeof cur !== "undefined" && cur !== null)
            return String(cur);
    }
    return undefined;
}
// Backward-compat alias while migrating naming to CLIENT_ORB.
if (!orbConfigs.CLIENT_STATE_ORB && orbConfigs.CLIENT_ORB) {
    orbConfigs.CLIENT_STATE_ORB = Object.assign(Object.assign({}, orbConfigs.CLIENT_ORB), { orbType: 'CLIENT_STATE_ORB' });
}
// ✅ Inject orbType into each config if not present
for (const [key, config] of Object.entries(orbConfigs)) {
    (_a = config.orbType) !== null && _a !== void 0 ? _a : (config.orbType = key);
}
export const OrbTypes = Object.freeze(orbConfigs);
export default { OrbTypes };
/**
 * **Dynamically Generated Enum-like Object for Known Orb Types**
 * - Always stays in sync with `orbConfigs`
 */
//export const OrbTypes = Object.freeze(
//    Object.fromEntries(Object.keys(orbConfigs).map((key) => [key, key]))
//);
// I think these below were different tests and not in use:
/**
 * **Merged Enum-like Object that holds both names and their config**
 * - Supports **dot notation** (`OrbTypes.PYTHON_ORB`)
 * - Supports **dynamic access** (`OrbTypes[orbType]`)
 */
//export const OrbTypes = Object.freeze(
//    Object.entries(orbConfigs).reduce((acc, [key, value]) => {
//        acc[key] = key;  // Store type name (for dot notation)
//        acc[key + '_CONFIG'] = value; // Store corresponding config
//        return acc;
//    }, {} as Record<string, string | IOrbStyleConfig>)
//);
/**
 * **Single Export for Orb Types & Configs**
 * - `OrbTypes.PYTHON_ORB` → `"PYTHON_ORB"` (string)
 * - `OrbTypes.PYTHON_ORB_CONFIG` → `{ radius: ..., scaleFactor: ..., colors: [...] }` (object)
 * - **Directly access configurations dynamically!** `OrbTypes[orbType]`
 * AI generated method of doing this, there might be a better way.
 * Usage: const config = OrbTypes[orbType] as IOrbStyleConfig;
 */
//export const OrbTypes: Record<string, string | IOrbStyleConfig> = Object.freeze({
//    ...Object.fromEntries(Object.keys(orbConfigs).map(key => [key, key])),
//    ...orbConfigs, // Store actual config inside the same object
//});
/**
 * `OrbTypes` is now a **directly mapped reference** to `orbConfigs`
 * - This allows both dot notation (`OrbTypes.RAINBOW_NEST`) and dynamic access (`OrbTypes[orbType]`).
 */
